// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"329fcd1b","161":"11ebc802","201":"096f2005","268":"19db1d5f","380":"17fa4259","499":"28cfd1ca","818":"fa3fa9e9"}[chunkId] + ".chunk.css";
};